// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingProduct_container__E-g4V","shine":"LoadingProduct_shine__1LLkF"};